import { render, staticRenderFns } from "./DtPedidos.vue?vue&type=template&id=7dd859f4&scoped=true"
import script from "./DtPedidos.vue?vue&type=script&lang=js"
export * from "./DtPedidos.vue?vue&type=script&lang=js"
import style0 from "./DtPedidos.vue?vue&type=style&index=0&id=7dd859f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd859f4",
  null
  
)

export default component.exports